import { Dispatch, SetStateAction } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export const AddStudentDropdownMenu = (props: {
  label: string;
  options: { id: number | string; desc: string }[];
  stateVal: number | string;
  stateValSet: Dispatch<SetStateAction<number>> | Dispatch<SetStateAction<string>>;
}) => (
  <FormControl fullWidth sx={{ my: 1 }}>
    <InputLabel id={`add-stu-${props.label.toLowerCase()}-label`}>{props.label}</InputLabel>
    <Select
      id={`add-stu-${props.label.toLowerCase()}`}
      label={props.label}
      labelId={`add-stu-${props.label.toLowerCase()}-label`}
      onChange={ev => props.stateValSet(ev.target.value as any)}
      value={props.stateVal}
    >
      {props.options.map(({ id, desc }) => (
        <MenuItem key={id} value={id}>
          {desc === "" ? "N/A" : desc}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
